import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

/** Row aligned with backend `HsnReportDto`. */
export interface HsnReportRow {
  branchId?: number | null;
  hsnCode?: string;
  uom?: string;
  cgstRate?: number;
  sgstRate?: number;
  igstRate?: number;
  totalBilledQuantity?: number;
  totalAmount?: number;
  totalCgst?: number;
  totalSgst?: number;
  totalIgst?: number;
}

class HsnReportApiService extends BaseApiService {
  async getHsnReport(
    branchId?: number,
    startDate?: string,
    endDate?: string
  ): Promise<ApiResponse<HsnReportRow[]>> {
    try {
      const response = await this.makeRequest<ApiResponse<HsnReportRow[]> | HsnReportRow[]>(
        API_ENDPOINTS.INVOICE_REPORTS.HSN(branchId, startDate, endDate),
        { method: HTTP_METHODS.GET }
      );

      if (Array.isArray(response)) {
        return {
          success: true,
          message: 'HSN report fetched successfully',
          data: response,
        };
      }

      return {
        success: Boolean(response?.success),
        message: response?.message || 'HSN report fetched successfully',
        data: Array.isArray(response?.data) ? response.data : [],
        timestamp: response?.timestamp,
        pagination: response?.pagination,
      };
    } catch (error) {
      toast.error('Failed to fetch HSN report');
      throw error;
    }
  }
}

export const hsnReportApiService = new HsnReportApiService();
